export const APPLY_LOAN_START = 'APPLY_LOAN_START';
export const APPLY_LOAN_SUCCESS = 'APPLY_LOAN_SUCCESS';
export const APPLY_LOAN_ERROR = 'APPLY_LOAN_ERROR';
export const APPLY_LOAN_END = 'APPLY_LOAN_END';
export const CLEAR_APPLY_LOAN = 'CLEAR_APPLY_LOAN';
